import * as React from 'react';
import { compose, pure, withHandlers } from 'recompose';
import InputAdornment from '@material-ui/core/InputAdornment';
import { createStyles, withStyles } from '@material-ui/styles';
import MuiTextField from '@material-ui/core/TextField';
import merge from 'lodash/merge';
const styles = (theme) => createStyles({
    root: {},
    label: {
        color: 'currentColor',
        fontWeight: theme.font.weight.normal,
    },
    suffix: {
        fontSize: theme.font.size.mediumSmall,
        color: 'currentColor',
        opacity: 0.58,
        marginLeft: 5,
        whiteSpace: 'nowrap',
    },
});
const TextInput = (props) => {
    const { classes, className, handleChange, postLabel, testId = 'TextInput', InputLabelProps: InputLabelProperties = {}, meta: { touched, error, invalid } = { touched: false, error: false, invalid: false }, InputProps: InputProperties = {}, input: { onChange = {}, ...inputProps } = {}, ...others } = props;
    return (React.createElement(MuiTextField, Object.assign({}, inputProps, others, { error: touched && invalid, helperText: touched && error, "data-testid": testId, onChange: (e) => handleChange(e.target.value), InputProps: merge({
            endAdornment: postLabel && (React.createElement(InputAdornment, { key: 'postLabel', classes: {
                    root: classes.suffix,
                }, disableTypography: true, position: "end" }, postLabel)),
        }, InputProperties), InputLabelProps: merge({ shrink: true, classes: { root: classes.label } }, InputLabelProperties), className: className })));
};
const ComposedTextInput = compose(withStyles(styles, { withTheme: true }), pure, withHandlers({
    handleChange: (props) => (val) => {
        if (props.input) {
            props.input.onChange(val);
        }
        else if (props.onChange) {
            props.onChange(val);
        }
    },
}))(TextInput);
ComposedTextInput.displayName = 'TextInput';
export default ComposedTextInput;
//# sourceMappingURL=TextInput.js.map